module.exports = __webpack_public_path__ + "static/media/arrow_footer.39db7b11.png";